<template>
  <TheTable :rows="rows" :columns="columns" :pagination="pagination" :loading="loading"
    @change-page="fetchData">
    <template v-slot:user="scope">
      <p>{{ scope.row.user.name + " " + scope.row.user.lastname }}</p>
    </template>
    <template v-slot:createdAt="scope">
      <p> {{ getDate(scope.row.createdAt) }}</p>
    </template>
    <template #actions="scope">
      <el-dropdown trigger="click">
        <el-button icon="fas fa-ellipsis-h" type="text"></el-button>
        <el-dropdown-menu slot="dropdown">
          <slot name="action-buttons" v-bind:row="scope.row"></slot>
          <el-dropdown-item icon="fas fa-trash" @click.native="handleDelete(scope.row)">{{ $t("common.delete")
            }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
  </TheTable>
</template>

<script>
import TheTable from '@/components/crud/TheTable'
import http from '@/api/http'
export default {
  data() {
    return {
      store: 'metaAccounts',
      loading : true,
      columns: [
        { index: 'name', label: this.$t('contact-me.chat-center.social-pages.account') },
        { index: 'user', label: this.$t('contact-me.chat-center.social-pages.added-by') },
        { index: 'createdAt', label: this.$t('contact-me.chat-center.social-pages.addAt') },
        { index: 'actions', label: '' },
      ]
    }
  },
  components: {
    TheTable
  },
  computed: {
    organizationId () {
      return this.$store.getters["contactMe/getOrganizationId"];
    },
    pagination () {
      return this.$store.getters[`${this.store}/getPagination`];
    },
    rows () {
      return this.$store.getters[`${this.store}/getData`]
    }
  }, 
  methods : {
    async fetchData(params = {}) {
      this.loading = true
      this.$store.commit('metaAccounts/IGNORE_CACHE', true)
      await this.$store.dispatch(`${this.store}/all`, {  ...params, ['organization.id'] : this.organizationId  })
      this.loading = false
    },
    getDate (dateString) {
      return new Date(dateString).toLocaleDateString([], { hour: '2-digit', minute: '2-digit' })
    },
    async handleDelete(row) {
      const response = await this.$confirm(this.$t('contact-me.chat-center.social-pages.are-you-sure-you-want-to-delete-the-account', { name : row.name }), 'Warning', {
        confirmButtonText: this.$t('common.yes'),
        cancelButtonText: this.$t('common.no'),
        type: 'warning'
      })

      if (response !== 'confirm') {
        return;
      }
      
      try {
        await http.delete('/meta/accounts/' + row.id)
        this.$message.success(this.$t('contact-me.chat-center.social-pages.the-account-was-removed-successfully', { name: row.name }));
        await this.fetchData();
      } catch (error) {
        this.$message.error(this.$t('contact-me-chat-center.social-pages.there-was-a-problem-trying-to-remove-the-account'));
      }
    },
  },
  mounted () {
    this.fetchData()
  },
}
</script>